import { render, staticRenderFns } from "./ModerationChecks.vue?vue&type=template&id=7e7a52f9"
import script from "./ModerationChecks.vue?vue&type=script&lang=js"
export * from "./ModerationChecks.vue?vue&type=script&lang=js"
import style0 from "./ModerationChecks.vue?vue&type=style&index=0&id=7e7a52f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports